module.exports = __webpack_public_path__ + "img/20220109_102843.5f89c7c7.jpg";